<template>
    <v-app>
        <customer-map-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Search Form
                            </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-form @submit.prevent="submit">
                                <v-row class="pa-2">
                                    <v-col  md="3" cols="12">
                                        <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="From Date"
                                        density="compact"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi mdi-calendar-month"
                                        single-line
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="from_date.value.value"
                                        :error-messages="from_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                        ></v-date-input>
                                    </v-col>

                                    <v-col  md="3" cols="12">
                                        <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="To Date"
                                        density="compact"
                                        single-line
                                        prepend-icon=""
                                        prepend-inner-icon="mdi mdi-calendar-month"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="to_date.value.value"
                                        :error-messages="to_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                        ></v-date-input>
                                        </v-col>

                                    <v-col lg="2" md="2" cols="12">
                                        <v-btn
                                            class="bg-brand w-15"
                                            type="submit"
                                            ref="searchButton"
                                            >Search</v-btn
                                        >
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>    
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Customer Map</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                      
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>
                                        
                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openAddCustomerMap"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Customer Map
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"                    
                                    density="compact">
                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>
                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import customerMapSetup from '@/components/module/inventory/customerManagement/customerMapSetup.vue';
import formattedDate from '@/plugins/dateFormatter';
import { useField, useForm } from 'vee-validate';
import { ref } from 'vue';
import { useStore } from 'vuex';
export default {
        components: {
            customerMapSetup
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "Customer",align: "left", key: "customer.name", sortable: true },
                { title: "Branch",align: "left", key: "branch.name", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created() {},
        computed:{
            getSchema() {
                return this.$store.getters.getCustomerMapList;
            },
        },
        setup() {
            const { handleSubmit, resetForm } = useForm();
            const from_date = useField("from_date");
            const to_date = useField("to_date");
            const errorMessages = ref("");
            const loading = ref("");
            const store = useStore();
            const submit = handleSubmit((values) => {
                loading.value = true;
                values.from_date = formattedDate(from_date.value.value);
                values.to_date = formattedDate(to_date.value.value);
                console.log(values)
                
                store.dispatch('getCustomerMapList', values).
                then(() => {
                    loading.value = false;
                }).catch((error) => {
                    loading.value = false;
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessages.value = error.response.data.message;
                        toast.error(errorMessages.value);
                    } else {
                        errorMessages.value = "An error occurred while fetching data.";
                        toast.error(errorMessages.value);
                    }
                });
            })
            return {
                from_date,
                to_date,
                errorMessages,
                loading,
                submit,
                resetForm
            };
        },
        methods: {
            openAddCustomerMap() {
                this.data = {
                    id: '',
                    branch_id: '',
                    status: 1,
                    branch:{
                        company_id: ''
                    },
                    customers_maps:{
                        customer_id: ''
                    }
                };
                this.dialog = true;
            },
            editItem(item){
                this.data = { ...item };
                this.dialog = true;
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Customer', 'Branch','Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.customer?.name, item.branch?.name, item.status == 1 ? 'Active' : 'Inactive']);
                this.$exportTableToPDF(columns,rows,'Customer Map List','customer_map_list_' + this.$fileDate())
            },
            exportToExcel() {
                var data = [['#SL', 'Customer', 'Branch','Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.customer?.name, item.branch?.name, item.status == 1 ? 'Active' : 'Inactive']);
                });
                this.$exportTableToExcel(data,'customer_map_list_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'Customer', 'Branch','Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.customer?.name, item.branch?.name, item.status == 1 ? 'Active' : 'Inactive']);
                });

                this.$exportTableToCSV(data,'customer_map_list_' + this.$fileDate());
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.searchButton.$el.click();
            });
        }  
    }
</script>